/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Agent
 */
export interface Agent {
    /**
     * 
     * @type {string}
     * @memberof Agent
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Agent
     */
    dreNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Agent
     */
    brokerage?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof Agent
     */
    lastSourceUpdateDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof Agent
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Agent
     */
    phone?: string | null;
}

/**
 * Check if a given object implements the Agent interface.
 */
export function instanceOfAgent(value: object): value is Agent {
    return true;
}

export function AgentFromJSON(json: any): Agent {
    return AgentFromJSONTyped(json, false);
}

export function AgentFromJSONTyped(json: any, ignoreDiscriminator: boolean): Agent {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'dreNumber': json['dreNumber'] == null ? undefined : json['dreNumber'],
        'brokerage': json['brokerage'] == null ? undefined : json['brokerage'],
        'lastSourceUpdateDate': json['lastSourceUpdateDate'] == null ? undefined : (new Date(json['lastSourceUpdateDate'])),
        'email': json['email'] == null ? undefined : json['email'],
        'phone': json['phone'] == null ? undefined : json['phone'],
    };
}

export function AgentToJSON(json: any): Agent {
    return AgentToJSONTyped(json, false);
}

export function AgentToJSONTyped(value?: Agent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'dreNumber': value['dreNumber'],
        'brokerage': value['brokerage'],
        'lastSourceUpdateDate': value['lastSourceUpdateDate'] === null ? null : ((value['lastSourceUpdateDate'] as any)?.toISOString()),
        'email': value['email'],
        'phone': value['phone'],
    };
}

